import { BaseDto } from 'src/dtos/common/baseDto';

/** 사원 학력 행과 화면 편집 상태이다. */
export interface HrmEducationDto extends BaseDto {
    empNo: string; // 사원번호
    eduSeq: number | null; // 사원별 순번, 신규는 null
    schoolNm: string; // 학교명
    majorNm: string; // 전공
    degreeCd: string; // 학위 코드
    admissionDt: string; // 입학일
    graduateDt: string; // 졸업일
    graduateType: string; // 졸업구분 코드
    location: string; // 소재지
    remark: string; // 비고
    inserted: boolean; // 저장되지 않은 행이면 true
    isModified: boolean; // 조회 후 수정했으면 true
}

/** 학력 신규 행의 기본값이다. */
export const defaultHrmEducationDto: HrmEducationDto = {
    valueIndex: 0, orderIndex: 0, orderIndexSeq: 0,
    empNo: '', eduSeq: null, schoolNm: '', majorNm: '', degreeCd: 'B',
    admissionDt: '1900-01-01', graduateDt: '1900-01-01', graduateType: 'G1',
    location: '', remark: '', inserted: false, isModified: false,
};
